import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { useStyles } from "../../../assets/jss/DialogTC";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CloseIcon from "../../../assets/images/close.svg";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useTranslation } from "react-i18next";
import CustomCheckbox from "../../CustomComponents/CustomCheckbox/CustomCheckbox";
import CustomFormControlLabel from "../../CustomComponents/CustomFormControlLabel/CustomFormControlLabel";
import CustomCircularProgress from "../../CustomComponents/CustomCircularProgress/CustomCircularProgress";
import { TableView } from "../../../config/app-globals.enum";
const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);

const modalInititalValues = [
    { title: 'SPEED_AND_SPEED_LIMIT', subtitle: 'CHECK_THE_SPEED_VS_SPEED_LIMIT_ALLOWED', checked: false },
    { title: 'DATE_AND_TIME', subtitle: 'CHECK_THE_DATE_AND_TIME_OF_THE_RECORDED_EVENT', checked: false },
    { title: 'EVENT_ON_THE_MAP', subtitle: 'CHECK_THE_EVENT_ON_THE_MAP_AND_MAKE_SURE_ITS_RECOREDED_CORRECTLY', checked: false },
    { title: 'SEVERITY', subtitle: 'CHECK_THE_SEVERITY_OF_THE_EVENT', checked: false },
    { title: 'REASON_FOR_REQUEST', subtitle: 'CHECK_THE_REASON_SUBMITTED_BY_DRIVER', checked: false },
]

export default function ApproveConfirmActionDialog(props) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [open, setOpen] = useState(props.dialogOpen);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [apiCall, setAPICall] = useState(false);
    const [modalValues, setModalValues] = useState(modalInititalValues);

    const handleClose = (confirmDelete) => {
        setAPICall(true);
        props.dialogClose(false, confirmDelete);

    };

    useEffect(() => {
        setIsAllChecked(true);
        setAPICall(false);
        setOpen(props.dialogOpen);
        modalValues.map((o) => {
            return o.checked = false;
        })
        setModalValues(modalValues);
    }, [props.dialogOpen]);


    useEffect(() => {
        if(props.tab === TableView.REPORT_EVENTS){
            const isAllChecked = modalValues.filter(o => o.checked === false);
            isAllChecked.length === 0 ? setIsAllChecked(false) : setIsAllChecked(true);
        } else {
            const isAllChecked = modalValues.filter(o => o.title !== "SPEED_AND_SPEED_LIMIT" && o.checked === false);
            isAllChecked.length === 0 ? setIsAllChecked(false) : setIsAllChecked(true);
        }
    }, [modalValues]);

    const handleChange = i => e => {
        let arr = [...modalValues];
        arr[i].checked = e.target.checked;
        setModalValues(arr);
    };
    
    return (
        <CustomDialog
            onClose={() => props.dialogClose(false)}
            aria-labelledby="customized-dialog-title"
            open={props.dialogOpen}
            className={classes.dialogWrapper}
        >
            <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={() => props.dialogClose(false)}
            >
                <img src={CloseIcon} />
            </IconButton>
            <DialogContent className={classes.approveDialogContentWrapper}>
                <Typography className={classes.titleLabel} >{t('DID_YOU_CHECK_ALL_THE_POINTS_BEFORE_APPROVE')}</Typography>
                <Typography className={classes.subtitleLabel}>{t('CAREFUL_WHILE_YOU_ARE_APPROVE_THE_REQUEST_IT_WILL_RECALCULATE_THE_DRIVER_SCORE')}</Typography>
                {
                    modalValues.map((obj, i) => {
                        return (
                            <React.Fragment key={i}>
                                {
                                    props.tab === TableView.REPORT_EVENTS ?
                                    <div className={classes.approveCheckList} >
                                        <CustomFormControlLabel
                                            control={<CustomCheckbox color="primary" checked={obj.checked} onChange={handleChange(i)} name={obj.title} />}
                                        />
                                        <div>
                                            <Typography className={classes.titleLabel}>{t(`${obj.title}`)}</Typography>
                                            <Typography className={classes.subtitleLabel}>{t(`${obj.subtitle}`)}</Typography> 
                                        </div> 
                                    </div>
                                    : obj.title !== "SPEED_AND_SPEED_LIMIT" ?
                                    <div className={classes.approveCheckList} >
                                        <CustomFormControlLabel
                                            control={<CustomCheckbox color="primary" checked={obj.checked} onChange={handleChange(i)} name={obj.title} />}
                                        />
                                        <div>
                                            <Typography className={classes.titleLabel}>{t(`${obj.title}`)}</Typography>
                                            <Typography className={classes.subtitleLabel}>{t(`${obj.subtitle}`)}</Typography> 
                                        </div> 
                                    </div> : null
                                }
                            </React.Fragment>
                        )
                    })
                }
            </DialogContent>
            <div className={classes.approveDialogActionWrapper}>
                {apiCall ? <CustomCircularProgress /> :
                    <CustomButton
                        className={classes.deleteView}
                        autoFocus
                        onClick={() => handleClose(true)}
                        variant="contained"
                        color="primary"
                        defaultrounded="true"
                        disabled={isAllChecked}
                    >
                        {t("APPROVE")}
                    </CustomButton>}
            </div>
        </CustomDialog>
    );
}
